export default "__VITE_ASSET__am3b4HNp__"